import * as React from 'react';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import DirectionsIcon from '@mui/icons-material/Directions';

export default function InputCustom({onSubmit, icon, placeholder, paperProps, inputProps, sx, ...props}) {
  return (
    <Paper
      component="form"
      onSubmit={(e)=>{
        e.preventDefault()
        if (typeof onSubmit === 'function') {
          onSubmit(e)
        }
      }}
      sx={sx}
      {...paperProps}
    >
      {
        icon?
        icon
        :null
      }
      <InputBase
        sx={{ flex: 1, py: 1, px: 2, fontSize: '16px' }}
        placeholder={placeholder}
        inputProps={inputProps}
        {...props}
      />
    </Paper>
  );
}
